import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)


export default new Router({
  mode: 'history',  //切换路径模式，变成history模式
  scrollBehavior: (to, from, savedPosition) => {
    return savedPosition || { x: 0, y: 0 }
  },//路由切换刷新到顶部
  routes: [
    { path: '*', component: require('@/components/error').default },
    {
      path: '/', //主页
      name: 'index',
      component: require('@/views/index/index').default,
      meta: { active: '/' }
    },
    {
      path: '/h5', //h5主页
      name: 'h5',
      component: require('@/views/h5/h5').default
    },
    // {
    //   path: '/PlayLine', //陪行
    //   name: 'PlayLine',
    //   component: require('@/views/index/PlayLine').default
    // },
    // 登录注册
    {
      path: '/login', //登录
      name: 'login',
      component: require('@/views/login/login').default
    },
    {
      path: '/register', //注册
      name: 'register',
      component: require('@/views/login/register').default
    },
    {
      path: '/userInfo', //完善资料
      name: 'userInfo',
      component: require('@/views/login/userInfo').default
    },
    {
      path: '/retrievePwd', //找回密码
      name: 'retrievePwd',
      component: require('@/views/login/retrievePwd').default
    },


    // 陪行
    {
      path: '/accompany', //陪行
      name: 'accompany',
      component: require('@/views/list/accompany').default,
      meta: { active: 'accompany' }
    },
    {
      path: '/hotList', //热门
      name: 'hotList',
      component: require('@/views/list/hotList').default,
      meta: { active: 'hotList' }
    },
    {
      path: '/city', //目的地城市
      name: 'city',
      component: require('@/views/list/city').default,
      meta: { active: 'city' }
    },


    // 心愿单
    {
      path: '/sponsorList', //心愿单
      name: 'sponsorList',
      component: require('@/views/sponsor/sponsorList').default,
      meta: { active: 'sponsorList' }
    },


    // 偶遇
    {
      path: '/encounter', //偶遇
      name: 'encounter',
      component: require('@/views/encounter/encounter').default,
      meta: { active: 'encounter' }
    },

    // 个人中心
    {
      path: '/home', //个人中心
      name: 'home',
      component: require('@/views/home/home').default,
      children: [
        {
          path: '/home/personal',//个人中心
          name: 'personal',
          component: require('@/views/home/personal').default
        },
        {
          path: '/home/authInfor',//用户资料
          name: 'authInfor',
          component: require('@/views/home/authInfor').default
        },
        {
          path: '/home/assets',//资金资产
          name: 'assets',
          component: require('@/views/home/assets').default
        },
        {
          path: '/home/order',//我的订单
          name: 'order',
          component: require('@/views/home/order').default
        },
        {
          path: '/home/endorsement',//我的心愿
          name: 'endorsement',
          component: require('@/views/home/endorsement').default
        },
        {
          path: '/home/endorsementAdd',//我的心愿
          name: 'endorsementAdd',
          component: require('@/views/home/endorsementAdd').default
        },
        {
          path: '/home/photoPage',//我的相册
          name: 'photoPage',
          component: require('@/views/home/photoPage').default
        },
        {//照片详情
          path: '/home/photoPage/showImageInfor',
          name: 'showImageInfor',
          component: require('@/views/home/showImageInfor').default
        },
        {
          path: '/home/dynamics',//我的相册
          name: 'dynamics',
          component: require('@/views/home/dynamics').default
        },
        {
          path: '/home/accountsecurity',//账户安全
          name: 'accountsecurity',
          component: require('@/views/home/accountsecurity').default,
        },
        {
          path: '/home/accountsecurity/modifyInfor',//修复绑定的二级页面
          name: 'modifyInfor',
          component: require('@/views/home/modifyInfor').default
        },
        {
          path: '/home/servicesList',//陪陪服务
          name: 'servicesList',
          component: require('@/views/home/services').default
        },
        {
          path: '/home/authenticate', //认证
          name: 'authenticate',
          component: require('@/views/home/authenticate').default
        },
        {
          path: '/home/services/service', //发布服务
          name: 'service',
          component: require('@/views/home/service').default
        },
        {
          path: '/home/accompaniedorders',//陪陪订单
          name: 'accompaniedorders',
          component: require('@/views/home/accompaniedorders').default
        },
      ]
    },


    // 我的主页
    {
      path: '/homePage', //我的主页
      name: 'homePage',
      component: require('@/views/homePage/homePage').default
    },

    // 定制旅行
    {
      path: '/customization', //定制旅行
      name: 'customization',
      component: require('@/views/customization/customization').default,
      meta: { active: 'customization' }
    },
    {
      path: '/team', //团队企业服务
      name: 'team',
      component: require('@/views/customization/team').default,
      meta: { active: 'team' }
    },

    // 订单
    {
      path: '/orderAdd', //添加订单
      name: 'orderAdd',
      component: require('@/views/order/orderAdd').default
    },
    {
      path: '/orderMoney', //支付订单
      name: 'orderMoney',
      component: require('@/views/order/orderMoney').default
    },
    {
      path: '/orderAwait', //等待确认
      name: 'orderAwait',
      component: require('@/views/order/orderAwait').default
    },


    // 关于我们
    {
      path: '/about', //关于我们
      name: 'about',
      component: require('@/views/about/about').default
    },
    {
      path: '/download', //下载APP
      name: 'download',
      component: require('@/views/about/download').default,
      meta: { active: 'download' }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js